module.exports = __webpack_public_path__ + "718061deddd1d93dc2ec8dc60bf0e3a1.png";